import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const PAGE_KEYS = ['about', 'services', 'blog', 'events', 'book', 'contact', 'gallery', 'admin'];

const setMeta = (selector, attrs, content) => {
  let tag = document.querySelector(selector);
  if (!tag) {
    tag = document.createElement('meta');
    Object.entries(attrs).forEach(([k, v]) => tag.setAttribute(k, v));
    document.head.appendChild(tag);
  }
  tag.content = content;
};

function SeoHead() {
  const { pathname } = useLocation();
  const { t, i18n } = useTranslation();

  useEffect(() => {
    if (pathname.startsWith('/blog/')) return;
    const segment = pathname.split('/')[1];
    const key = PAGE_KEYS.includes(segment) ? segment : null;
    const title = key ? `${t(`pageTitles.${key}`)} | Casapooch` : t('meta.title');
    const description = key && key !== 'admin' ? t(`pageDescriptions.${key}`) : t('meta.description');

    document.title = title;
    setMeta('meta[name="description"]', { name: 'description' }, description);
    setMeta('meta[property="og:title"]', { property: 'og:title' }, title);
    setMeta('meta[property="og:description"]', { property: 'og:description' }, description);
    setMeta('meta[property="og:locale"]', { property: 'og:locale' }, t('meta.locale'));
    setMeta('meta[property="og:type"]', { property: 'og:type' }, 'website');
    setMeta('meta[property="og:url"]', { property: 'og:url' }, window.location.href);
  }, [pathname, i18n.language, t]);

  return null;
}

export default SeoHead;
